import customAxios from "./axiosConfig";

const TransactionService = {
  retrieve: function(pk){
    var api_url = window.Urls['transaction-detail'](pk);
    return customAxios.get(api_url);
  },
  list: function (params) {
    var api_url = window.Urls['transaction_list']();
    return customAxios.get(api_url,  { params: params });
  },
  create: function(data) {
      var api_url = window.Urls['transaction-list']();
      return customAxios.post(api_url, data);
  },
  update: function(pk, data){
      var api_url = window.Urls['transaction-detail'](pk);
      return customAxios.put(api_url, data);
  },
  inititateAdyenPaymentSession: function (pk, data){
    var api_url = window.Urls['transaction_initiate_adyen_payment_session'](pk);
    return customAxios.post(api_url, data);
  },
  validate: function (data){
    var api_url = window.Urls['transaction_validate']();
    return customAxios.post(api_url, data);
  }
};

export default TransactionService;
